export default "select name, profile, min_concurrency, max_concurrency from sys.wlm_resource_pools_for_query($(queryId))\n"